import React from "react";
import { Button, Typography, useMediaQuery } from "@mui/material";
import { styled } from "@mui/system";
import { useAssessment } from "../../providers/AssessmentProvider";
import { useGuidedMode } from "../../providers/GuidedModeProvider";

const SquareButton = styled(Button)(
  ({ isSelected, guidedMode, isMobile, isYesNo }) => {
    let width = "62px";
    if (!guidedMode) {
      width = "40px";
      if (isMobile) width = "80px";
      if (isYesNo) width = "60px";
      if (isMobile && isYesNo) width = "250px";
    }
    return {
      width: width,
      height: !guidedMode ? "40px" : "60px",
      minWidth: width,
      margin: !guidedMode ? "6px" : "10px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: isSelected ? "#09306D !important" : "white",
      color: !isSelected ? "#09306D" : "#ffffff",
      border: "1px solid #09306D",
    };
  }
);

const ButtonContainer = styled("div")(({ alignLeft }) => ({
  display: "flex",
  padding: "0px !important",
  flexDirection: "column",
  alignItems: alignLeft ? "flex-start" : "center",
}));

const CustomButton = ({
  value,
  label,
  selectedTab,
  isSelected,
  section,
  subSectionindex,
  questionIndex,
}) => {
  const { guidedMode } = useGuidedMode();
  const { handleAssessmentToggle } = useAssessment();
  const isMobile = useMediaQuery("(max-width: 900px)");
  const isYesNo = typeof value === "string";
  const alignLeft = guidedMode && isMobile;

  return (
    <ButtonContainer alignLeft={alignLeft}>
      <SquareButton
        isSelected={isSelected}
        guidedMode={guidedMode}
        isMobile={isMobile}
        isYesNo={isYesNo}
        onClick={() =>
          handleAssessmentToggle(section, subSectionindex, questionIndex, value)
        }
      >
        <Typography
          fontSize={!guidedMode ? 15 : 20}
          fontWeight={!guidedMode ? 600 : 700}
        >
          {value}
        </Typography>
      </SquareButton>

      {guidedMode && !isYesNo && selectedTab !== 2 && (
        <Typography
          style={{
            color: "#09306D",
            fontSize: "14px",
          }}
        >
          {label}
        </Typography>
      )}
    </ButtonContainer>
  );
};

export default CustomButton;
